export default {
  LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
  SET_VIDEO_PROGRESS: 'SET_VIDEO_PROGRESS',
  STOP_VIDEO_PLAY: 'STOP_VIDEO_PLAY',
};
